import React from 'react';
import { Route } from 'react-router';
export default (
  <Route
    path="departmentnews"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  />
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/DepartmentNews/screens/User/router.js
 **/